import React from 'react';
import clsx from 'clsx';
import { Box, makeStyles } from '@material-ui/core';
import { colors } from 'design-system';
import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles({
  buttonBox: {
    fontWeight: 'bold',
    fontSize: 14,
    fontStyle: 'normal',
    lineHeight: '24px',
    backgroundColor: 'white',
    borderRadius: 25,
    height: 50,
    padding: '10px 30px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 250,
  },
  buttonActive: {
    color: colors.bright_turquoise,
    border: `1px solid ${colors.bright_turquoise}`,
    '&:hover': {
      backgroundColor: 'rgba(0, 194, 255, 0.12)',
    },
  },
  buttonDisabled: {
    color: colors.light_silver,
    border: `1px solid ${colors.silver}`,
  },
});

type Props = {
  id?: string;
  disabled?: boolean;
};

const AddFileButton = ({ id, disabled }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Box
      id={`${id}-icon`}
      data-testid="take-local-photo-button"
      color="primary"
      component="span"
      className={clsx(
        classes.buttonBox,
        disabled ? classes.buttonDisabled : classes.buttonActive,
      )}
      onClick={(e): void => {
        if (disabled) {
          e.preventDefault();
        }
      }}
    >
      <FontAwesomeIcon
        data-testid="add-file-button"
        icon={faCirclePlus}
        fontSize={24}
        color={disabled ? colors.light_silver : colors.bright_turquoise}
      />
      &nbsp;&nbsp; AÑADIR
    </Box>
  );
};

export default AddFileButton;
